import { Alert, Divider, Box as MuiBox, Paper, Stack, Tooltip, Typography } from '@mui/material';
import { Loading } from 'components/elements';
import Switch from 'components/elements/switch';
import { getPreferenceByName } from 'helpers/members';
import { EFeatures } from 'lib/feature/features.types';
import { PreferenceName } from 'node-api/members/member.types';
import MembersClient from 'node-api/members/MembersClient';
import { FC, useContext, useEffect, useState } from 'react';
import { FeaturesContext } from 'state/contexts/features';
import { PatientContext } from 'state/contexts/patient';
import { ActionTypes as PatientActionTypes } from 'state/reducers/patient';
import '../style.css';

const UserPreferencesBox: FC = () => {
  const [loading, setLoading] = useState<boolean>(true);

  const { patientState, patientDispatch } = useContext(PatientContext);
  const { featuresState } = useContext(FeaturesContext);

  const memberPreferences = patientState.current?.preferences ?? [];

  const audioRecordingPreference = getPreferenceByName(
    memberPreferences,
    PreferenceName.VideoCallAutomaticRecording
  );

  useEffect(() => {
    const { current } = patientState;

    if (!current || current.preferences?.length) {
      return;
    }

    setLoading(true);

    (async () => {
      const fetchedMemberPreferences = await new MembersClient().getMemberPreferences(
        Number(current!.id)
      );

      if (fetchedMemberPreferences) {
        patientDispatch({
          type: PatientActionTypes.SET_PREFERENCES,
          payload: { preferences: fetchedMemberPreferences },
        });
      }

      setLoading(false);
    })();
  }, [patientState.current]);

  if (!featuresState?.[EFeatures.MembersWebAppAllowAutoRecording]) {
    return null;
  }

  return (
    <Paper elevation={1}>
      <Stack divider={<Divider flexItem />} p={2} spacing={1}>
        {loading || memberPreferences.length === 0 ? (
          <Loading />
        ) : (
          <>
            {featuresState?.[EFeatures.MembersWebAppAllowAutoRecording] && (
              <Alert variant='outlined' severity='info' className='preference-container'>
                <MuiBox display='flex' justifyContent='space-between'>
                  <Typography component='h5'>
                    Audio recording is {audioRecordingPreference?.value ? 'enabled' : 'disabled'}
                  </Typography>

                  <Tooltip title='Providers cannot change this setting' placement='left-start'>
                    <Switch checked={!!audioRecordingPreference?.value} />
                  </Tooltip>
                </MuiBox>
              </Alert>
            )}
          </>
        )}
      </Stack>
    </Paper>
  );
};

export default UserPreferencesBox;
